var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.93164,
    width: 50,
    height: 50,
    rx: 25,
    stroke: "#E1EEDD",
    strokeWidth: 12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3324_44573",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 54,
    height: 55
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.93164,
    width: 54,
    height: 54,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3324_44573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8068 36.7605L22.5798 31.5336C22.2683 31.222 21.8767 31.0626 21.4051 31.0554C20.9335 31.0482 20.5347 31.2076 20.2087 31.5336C19.8828 31.8595 19.7198 32.2547 19.7198 32.7191C19.7198 33.1835 19.8828 33.5787 20.2087 33.9046L26.3832 40.0791C26.79 40.4858 27.2645 40.6892 27.8068 40.6892C28.3491 40.6892 28.8236 40.4858 29.2303 40.0791L41.7481 27.5614C42.0596 27.2498 42.219 26.8583 42.2262 26.3866C42.2335 25.915 42.0741 25.5162 41.7481 25.1902C41.4221 24.8643 41.027 24.7013 40.5626 24.7013C40.0982 24.7013 39.703 24.8643 39.377 25.1902L27.8068 36.7605ZM31.0038 53.3065C28.0475 53.3065 25.2687 52.7455 22.6674 51.6235C20.066 50.5015 17.8032 48.9788 15.879 47.0555C13.9547 45.1321 12.4313 42.8703 11.3089 40.2701C10.1864 37.67 9.62512 34.8917 9.62512 31.9354C9.62512 28.979 10.1861 26.2002 11.3081 23.5989C12.4301 20.9975 13.9528 18.7348 15.8762 16.8105C17.7996 14.8862 20.0614 13.3629 22.6616 12.2404C25.2617 11.1179 28.0399 10.5566 30.9963 10.5566C33.9526 10.5566 36.7315 11.1176 39.3328 12.2396C41.9341 13.3616 44.1969 14.8843 46.1211 16.8077C48.0454 18.7311 49.5688 20.9929 50.6913 23.5931C51.8138 26.1932 52.375 28.9715 52.375 31.9278C52.375 34.8842 51.814 37.663 50.692 40.2643C49.57 42.8656 48.0473 45.1284 46.124 47.0527C44.2005 48.9769 41.9387 50.5003 39.3386 51.6228C36.7384 52.7453 33.9602 53.3065 31.0038 53.3065Z",
    fill: "#82B770"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertGreen);
export default __webpack_public_path__ + "static/media/AlertGreen.1452c86a32f7e26690c54056ddd601f6.svg";
export { ForwardRef as ReactComponent };